import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Input, Radio, Row, Upload } from "antd";
import React, { FC } from "react";
import { Form } from "antd";

type EnhancementIhxBasicDetailsProps = {
  form: any;
};

const EnhancementIhxBasicDetails: FC<EnhancementIhxBasicDetailsProps> = ({
  form,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "14px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Basic Details
      </div>

      <Form form={form} layout="vertical" style={{ margin: "16px 0" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="DATE OF Admission"
              name="dateOfAdmission"
              style={{ color: "black" }}
              //   rules={[
              //     {
              //       required: true,
              //       message: "Please input DATE OF admission",
              //     },
              //   ]}
            >
              <DatePicker style={{ width: "100%" }} format={dateFormat} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="DATE OF DISCHARGE"
              name="dateOfDischarge"
              style={{ color: "black" }}
              //   rules={[
              //     {
              //       required: true,
              //       message: "Please input DATE OF DISCHARGE",
              //     },
              //   ]}
            >
              <DatePicker style={{ width: "100%" }} format={dateFormat} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Remarks"
              name="remarks"
              style={{ color: "#575757" }}
              //   rules={[
              //     {
              //       required: true,
              //       message: "Please input Ipd no",
              //     },
              //   ]}
            >
              <Input
                placeholder="Please input remarks"
                style={{ color: "black" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EnhancementIhxBasicDetails;
